'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var alert = {
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '12px',
  lineHeight: '15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5px 10px',
  minHeight: '28px',
  variants: {
    primary: {
      bg: 'rgba(126, 79, 195, 0.1)',
      color: '#351E57'
    },
    warning: {
      bg: '#FFF6DB',
      color: '#806519'
    },
    error: {
      bg: '#FDECEF',
      color: '#EF435D'
    },
    success: {
      bg: '#E5F9F3',
      color: '#009E6A'
    },
    plain: {
      bg: '#F2F2F2',
      color: '#444444'
    }
  }
};

exports.default = alert;
